import { PrimProductDetail } from "@/stf.ui/prim.product-detail";

import { useQtyState } from "./product-qty.state";

interface QtySelectorProps {
  disabled?: boolean;
}
const QtySelector = (props: QtySelectorProps) => {
  const { disabled } = props;

  const {
    onMinus,
    onPlus,
    qty,
    setQty,
  } = useQtyState();

  return (
    <PrimProductDetail.QtySelector
      disabled={disabled}
      onMinus={onMinus}
      onPlus={onPlus}
      qty={qty}
      setQty={setQty}
    />
  );
};

export { QtySelector };
